// // 

// import React, { useState, useEffect } from "react";
// import CreatableSelect from "react-select/creatable";
// import logger from "../../../utils/logger";
// import { MemberService } from "../../../services/MemberService";
// import classNames from "classnames";
// import { useRef } from "react";
// import { FormationService } from "../../../services/formationService";



// export const GenericCreatableSelect = React.forwardRef(
//   (
//     {
//       name,
//       placeholder,
//       setValue,
//       preValue = [],
//       multi,
//       selecteClasss = "",
//     },
//     ref
//   ) => {
//     const preValueAppliedRef = useRef(false);
//     const [options, setOptions] = useState([]);
//     const [inputValue, setInputValue] = useState("");
//     const MAX_PROFESSORS = 10;

//     const [selected, setSelected] = useState(
//       preValue.map((v) => ({ label: v, value: v }))
//     );

//     const [touched, setTouched] = useState(false);
//     const showError = touched && selected.length === 0;

//     // 🔁 Sincronizar preValue con RHF
//     useEffect(() => {
//       if (
//         !preValueAppliedRef.current &&
//         Array.isArray(preValue) &&
//         preValue.length > 0
//       ) {
//         const mapped = preValue.map(v => ({ label: v, value: v }));

//         setSelected(mapped);

//         setValue(
//           name,
//           preValue,
//           {
//             shouldValidate: true,
//             shouldDirty: false,
//           }
//         );

//         preValueAppliedRef.current = true; // 🔒 BLOQUEA LOOP
//       }
//     }, [preValue, name, setValue]);


//     // 📡 Obtener sugerencias
//     useEffect(() => {
//       const fetchData = async () => {
//         try {
//           const response = await FormationService.getProfessors({ professorName: `` })

//           if (response?.data?.length > 0) {
//             const mapped = response.data.map((p) => ({
//               value: p.id,
//               label: p.name,
//             }));
//             setOptions(mapped);
//           }
//         } catch (error) {
//           logger.error("Error obteniendo sugerencias", error);
//         }
//       };

//       fetchData();
//     }, []);

//     const normalize = (str) => str.trim().toLowerCase();

//     const existsInSelected = (label) =>
//       selected.some(
//         (item) => normalize(item.label) === normalize(label)
//       );

//     const createOption = (label) => ({
//       label,
//       value: label,
//     });

//     // ➕ Agregar tag manual
//     const addTag = (label) => {
//       if (selected.length >= MAX_PROFESSORS) return;
//       if (existsInSelected(label)) return;

//       const newTag = createOption(label);
//       const updated = [...selected, newTag];

//       setSelected(updated);
//       setValue(
//         name,
//         updated.map((o) => o.label),
//         { shouldValidate: true, shouldDirty: true }
//       );

//       setTouched(false);
//     };

//     // ⌨️ Enter / ;
//     const handleInputChange = (value) => {
//       if (value.endsWith(";")) {
//         const clean = value.slice(0, -1).trim();
//         if (clean) addTag(clean);
//         return "";
//       }

//       setInputValue(value);
//       return value;
//     };

//     // 🔄 Selección normal
//     const handleChange = (value) => {
//       const incoming = value || [];

//       const unique = [];
//       const seen = new Set();

//       for (const item of incoming) {
//         const key = normalize(item.label);
//         if (!seen.has(key)) {
//           seen.add(key);
//           unique.push(item);
//         }
//       }

//       if (unique.length > MAX_PROFESSORS) return;

//       setSelected(unique);
//       setValue(
//         name,
//         unique.map((v) => v.label),
//         { shouldValidate: true, shouldDirty: true }
//       );
//     };

//     const handleBlur = () => {
//       setTouched(true);
//     };

//     logger.debug("Selected:", selected);

//     return (
//       <div className="w-100">
//         <CreatableSelect
//           ref={ref}
//           isMulti={multi}
//           name={name}
//           placeholder={placeholder}
//           value={selected}
//           options={options}
//           onChange={handleChange}
//           onInputChange={handleInputChange}
//           onCreateOption={addTag}
//           onBlur={handleBlur}
//           menuPlacement="auto"
//           noOptionsMessage={() =>
//             inputValue.length < 2
//               ? "Escribe al menos 2 caracteres..."
//               : "Sin coincidencias"
//           }
//           className={classNames(selecteClasss)}
//           formatCreateLabel={(inputValue) =>
//             `¿Desea agregar "${inputValue}"?`
//           }


//           styles={{
//             control: (base) => ({
//               ...base,
//               borderRadius: "22px",
//               borderColor: showError ? "#F06292" : base.borderColor,
//               backgroundColor: showError ? "#fdefef" : base.backgroundColor,
//               boxShadow: "none",
//             }),

//             multiValue: (base) => ({
//               ...base,
//               backgroundColor: "#e3e3e3",
//               borderRadius: "7px",
//               paddingInline: "4px",
//             }),

//             multiValueLabel: (base) => ({
//               ...base,
//               color: "#757575",
//               fontWeight: "500",
//             }),

//             multiValueRemove: (base) => ({
//               ...base,
//               color: "#757575",
//               ":hover": {
//                 backgroundColor: "#3a3838ff",
//                 color: "#fff",
//               },
//             }),
//           }}
//         />

//         {showError && (
//           <span className="invalid-feedback d-flex field-validation-error">
//             <span className="error-message">Campo requerido</span>
//           </span>
//         )}
//       </div>
//     );
//   }
// );


import React, { useState, useEffect, useRef } from "react";
import CreatableSelect from "react-select/creatable";
import classNames from "classnames";
import logger from "../../../utils/logger";
import { FormationService } from "../../../services/formationService";

export const GenericCreatableSelect = React.forwardRef(
  (
    {
      name,
      placeholder,
      setValue,
      preValue = [],
      multi,
      selecteClasss = "",
    },
    ref
  ) => {
    const preValueAppliedRef = useRef(false);

    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [selected, setSelected] = useState(
      preValue.map(v => ({ label: v, value: v }))
    );

    const [touched, setTouched] = useState(false);

    const MAX_PROFESSORS = 10;
    const MIN_CHARS = 3;

    const showError = touched && selected.length === 0;

    /* ------------------ Sync preValue ------------------ */
    useEffect(() => {
      if (
        !preValueAppliedRef.current &&
        Array.isArray(preValue) &&
        preValue.length > 0
      ) {
        const mapped = preValue.map(v => ({ label: v, value: v }));

        setSelected(mapped);
        setValue(name, preValue, {
          shouldValidate: true,
          shouldDirty: false,
        });

        preValueAppliedRef.current = true;
      }
    }, [preValue, name, setValue]);

    /* ------------------ Fetch API ------------------ */
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await FormationService.getProfessors({
            professorName: "",
          });

          if (response?.data?.length) {
            setOptions(
              response.data.map(p => ({
                label: p.name,
                value: p.id,
              }))
            );
          }
        } catch (err) {
          logger.error("Error obteniendo profesores", err);
        }
      };

      fetchData();
    }, []);

    /* ------------------ Utils ------------------ */
    const normalize = str => str.trim().toLowerCase();

    const existsInSelected = label =>
      selected.some(item => normalize(item.label) === normalize(label));

    const createOption = label => ({ label, value: label });

    /* ------------------ Derived Options ------------------ */
    const filteredOptions =
      inputValue.length >= MIN_CHARS
        ? options.filter(o =>
            o.label.toLowerCase().includes(inputValue.toLowerCase())
          )
        : [];

    /* ------------------ Add manual tag ------------------ */
    const addTag = label => {
      if (selected.length >= MAX_PROFESSORS) return;
      if (existsInSelected(label)) return;

      const updated = [...selected, createOption(label)];

      setSelected(updated);
      setValue(
        name,
        updated.map(o => o.label),
        { shouldValidate: true, shouldDirty: true }
      );

      setTouched(false);
    };

    /* ------------------ Input ------------------ */
    const handleInputChange = value => {
      if (value.endsWith(";")) {
        const clean = value.slice(0, -1).trim();
        if (clean) addTag(clean);
        return "";
      }

      setInputValue(value);
      return value;
    };

    /* ------------------ Select ------------------ */
    const handleChange = value => {
      const incoming = value || [];

      const unique = [];
      const seen = new Set();

      for (const item of incoming) {
        const key = normalize(item.label);
        if (!seen.has(key)) {
          seen.add(key);
          unique.push(item);
        }
      }

      if (unique.length > MAX_PROFESSORS) return;

      setSelected(unique);
      setValue(
        name,
        unique.map(v => v.label),
        { shouldValidate: true, shouldDirty: true }
      );
    };

    const handleBlur = () => setTouched(true);

    logger.debug("Selected:", selected);

    return (
      <div className="w-100">
        <CreatableSelect
          ref={ref}
          isMulti={multi}
          name={name}
          placeholder={placeholder}
          value={selected}
          options={filteredOptions}
          onChange={handleChange}
          onInputChange={handleInputChange}
          onCreateOption={addTag}
          onBlur={handleBlur}
          menuPlacement="auto"
          noOptionsMessage={() =>
            inputValue.length < MIN_CHARS
              ? "Escribe al menos 3 caracteres..."
              : "Sin coincidencias"
          }
          className={classNames(selecteClasss)}
          formatCreateLabel={inputValue =>
            `¿Desea agregar "${inputValue}"?`
          }
          styles={{
            control: base => ({
              ...base,
              borderRadius: "22px",
              borderColor: showError ? "#F06292" : base.borderColor,
              backgroundColor: showError ? "#fdefef" : base.backgroundColor,
              boxShadow: "none",
            }),
            multiValue: base => ({
              ...base,
              backgroundColor: "#e3e3e3",
              borderRadius: "7px",
              paddingInline: "4px",
            }),
            multiValueLabel: base => ({
              ...base,
              color: "#757575",
              fontWeight: "500",
            }),
            multiValueRemove: base => ({
              ...base,
              color: "#757575",
              ":hover": {
                backgroundColor: "#3a3838ff",
                color: "#fff",
              },
            }),
          }}
        />

        {showError && (
          <span className="invalid-feedback d-flex field-validation-error">
            <span className="error-message">Campo requerido</span>
          </span>
        )}
      </div>
    );
  }
);
